import { render, staticRenderFns } from "./basicLayout.vue?vue&type=template&id=ef94c2fa&scoped=true&"
import script from "./basicLayout.vue?vue&type=script&lang=js&"
export * from "./basicLayout.vue?vue&type=script&lang=js&"
import style0 from "./basicLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./basicLayout.vue?vue&type=style&index=1&id=ef94c2fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef94c2fa",
  null
  
)

export default component.exports